import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import { Button, Icon, Modal } from '@gerdau/hefesto';
import { Chips } from '@gerdau/hefesto-mais-web';
import {
  IUserPreference,
  EInvoiceColumn,
  ISaveUser
} from '../../../../../../store/ducks/user/types';
import {
  updateUserPreferences,
  saveUser as saveUserAction
} from '../../../../../../store/ducks/user/actions';
import { ModalContent } from './styles';
import { sendTagging } from '../../../../../../store/ducks/tagging/actions';
import { ITaggingParams } from '../../../../../../store/ducks/tagging/types';

interface ISettingTableProps {
  orderUserPreference?: IUserPreference;
  setOrderUserPreference: (preference: IUserPreference) => void;
}

const SettingTable: React.FC<ISettingTableProps> = ({
  orderUserPreference,
  setOrderUserPreference
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state: ApplicationState) => state.user);
  const [canShowModal, setCanShowModal] = useState(false);
  const [selectedChips, setSelectedChips] = useState<string[]>([
    orderUserPreference?.ordersItensFinancials?.idOrder ||
      EInvoiceColumn.ORDER_NUMBER
  ]);
  const [selectedChipsOld, setSelectedChipsOld] = useState<string>(
    orderUserPreference?.ordersItensFinancials?.idOrder ||
      EInvoiceColumn.ORDER_NUMBER
  );
  const optionsChoice = [
    { id: EInvoiceColumn.ORDER_NUMBER, label: 'Pelo Número do pedido' },
    { id: EInvoiceColumn.SALES_ORDERS, label: 'Pela Ordem de Venda da Gerdau' }
  ];

  const setIdOrder = (id: string) => {
    if (orderUserPreference && !orderUserPreference.ordersItensFinancials) {
      orderUserPreference.ordersItensFinancials = {
        idOrder: EInvoiceColumn.ORDER_NUMBER
      };
    }
    if (orderUserPreference && orderUserPreference.ordersItensFinancials) {
      const newOrderUserPreference: IUserPreference = {
        ...orderUserPreference,
        ordersItensFinancials: {
          ...orderUserPreference.ordersItensFinancials,
          idOrder: id
        }
      };
      dispatch(updateUserPreferences(newOrderUserPreference));
      setOrderUserPreference(newOrderUserPreference);
    }
  };

  const saveUser = () => {
    const tpPdd =
      selectedChips[0] === '0' ? 'numero_pedido' : 'ordem_venda_gerdau';

    const taggingParams: ITaggingParams = {
      screenName: 'LG:Financas:MinhasFinancas:Duplicatas:ModalConfiguracao',
      event: 'click',
      itemName: 'button:salvar_configuracoes',
      itemDescription:
        'financas_minhas_financas_duplicatas_modalConfiguracao_salvarConfiguracoes',
      filterInfo: `#tpPdd:${tpPdd}`
    };
    dispatch(sendTagging(taggingParams));

    if (orderUserPreference && orderUserPreference.ordersItensFinancials) {
      const saveUserProps: ISaveUser = {
        user: user
      };
      dispatch(saveUserAction(saveUserProps));
      setSelectedChipsOld(
        orderUserPreference?.ordersItensFinancials?.idOrder ||
          EInvoiceColumn.ORDER_NUMBER
      );
    }
    setCanShowModal(false);
  };

  const cancelSelectedChip = () => {
    const tpPdd =
      selectedChips[0] === '0' ? 'numero_pedido' : 'ordem_venda_gerdau';

    const taggingParams: ITaggingParams = {
      screenName: 'LG:Financas:MinhasFinancas:Duplicatas:ModalConfiguracao',
      event: 'click',
      itemName: 'button:cancelar',
      itemDescription:
        'financas_minhas_financas_duplicatas_modalConfiguracao_cancelar',
      filterInfo: `#tpPdd:${tpPdd}`
    };
    dispatch(sendTagging(taggingParams));

    if (orderUserPreference && orderUserPreference.ordersItensFinancials) {
      const newOrderUserPreference: IUserPreference = {
        ...orderUserPreference,
        ordersItensFinancials: {
          ...orderUserPreference.ordersItensFinancials,
          idOrder: selectedChipsOld
        }
      };
      dispatch(updateUserPreferences(newOrderUserPreference));
      setSelectedChips([selectedChipsOld]);
      setCanShowModal(false);
    }
  };

  const showModal = () => {
    const taggingParams: ITaggingParams = {
      screenName: 'LG:Financas:MinhasFinancas:Duplicatas',
      event: 'click',
      itemName: 'button:configurar_tabela',
      itemDescription: 'financas_minhas_financas_duplicatas_configurarTabela'
    };
    dispatch(sendTagging(taggingParams));
    setCanShowModal(true);
    dispatch(
      sendTagging({
        screenName: 'LG:Financas:MinhasFinancas:Duplicatas:ModalConfiguracao',
        event: 'page_view'
      })
    );
  };

  return (
    <>
      <Button
        name="settingTable"
        onClick={showModal}
        variant="secondary"
        icon={<Icon option="Settings" />}
        iconPosition="left"
      >
        Configurar tabela
      </Button>

      {canShowModal && (
        <Modal
          title="Configurar tabela"
          onClose={() => {
            setCanShowModal(false);
          }}
          buttons={{
            left: {
              children: 'Cancelar',
              name: 'cancelar',
              onClick: cancelSelectedChip,
              type: 'button'
            },
            right: {
              children: 'Salvar configurações',
              name: 'salvar-configuracoes',
              onClick: saveUser,
              type: 'button'
            }
          }}
          modalSize="sm"
        >
          <span>Como deseja identificar seu pedido?</span>
          <ModalContent>
            <Chips
              chips={optionsChoice}
              selectedChipIds={selectedChips}
              type="choice"
              handleSelect={(e) => {
                if (e.length) {
                  const [option] = e;
                  setIdOrder(option);
                  setSelectedChips(e);
                  return;
                }

                setSelectedChips([
                  orderUserPreference?.ordersItensFinancials?.idOrder ||
                    EInvoiceColumn.ORDER_NUMBER
                ]);
              }}
            />
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default SettingTable;
